import request from "../services/request";
import { API_BASE_URL } from "../services/const";
import { method } from "lodash";

export const getCustomerByMobile = (data) => request(`${API_BASE_URL}/getCustomerByMobile`, { method: "POST", data, });

export const getTodayPayments = (data) => request(`${API_BASE_URL}/todayEmisCollected/pradeep`, { method: "POST", data, });

export const addPayment = (data) => request(`${API_BASE_URL}/payment`, { method: "POST", data }); 